export const localStorageMiddleware = ({ getState }) => {
  return (next) => (action) => {
    const result = next(action);
    if (action.type.startsWith('allItemsCart/')) {
      localStorage.setItem('allItemsCart', JSON.stringify(getState().allItemsCart.allItemsCart));
    }
    return result;
  };
};